'use strict';

import FailIcon from '@material-ui/icons/Close';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import bemit from 'Functions/bemit';
import Link from 'Pure/Link';
export default function PaymentCanceled(props) {
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-payment-form', ['failure'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-payment-form__content"
  }, /*#__PURE__*/React.createElement(FailIcon, {
    className: "c-payment-form__failure-icon"
  }), getFormStatus({
    error: 'Réservation annulée.'
  }), /*#__PURE__*/React.createElement(Link, {
    href: "/",
    className: bemit('c-flat-btn', ['front', 'payment-back-home'])
  }, /*#__PURE__*/React.createElement("strong", null, '<'), "\xA0Retourner \xE0 l'accueil")));
  return output;
}
